@if (open) {
  <div
    class="dialog-backdrop"
    role="presentation"
    (click)="onBackdropClick()"
  >
    <section
      class="dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title"
      (click)="stopPropagation($event)"
    >
      <header class="dialog__header">
        <div class="dialog__heading">
          @if (tone !== 'default') {
            <span
              class="dialog__icon"
              [class]="'dialog__icon dialog__icon--' + tone"
              aria-hidden="true"
            >
              @switch (tone) {
                @case ('info') { i }
                @case ('success') { ✓ }
                @default { ! }
              }
            </span>
          }

          <h2>{{ title }}</h2>
        </div>

        <button
          class="dialog__close"
          type="button"
          aria-label="Dialog schließen"
          (click)="close()"
        >
          ×
        </button>
      </header>

      <div class="dialog__content">
        <ng-content />
      </div>
    </section>
  </div>
}
